import React, { useState, useContext, useRef } from "react";
import { useParams } from "react-router-dom";
import { AuthContext } from "../../../../Context/Auth";
import {
  DialogContent,
  Grid,
  Typography,
  Button,
  TextField,
  Dialog,
  DialogActions,
  DialogTitle,
  IconButton,
} from "@material-ui/core";

import { Close } from "@material-ui/icons";

import { PrimaryButton } from "../../../../Shared/Buttons";
import ConfirmationModal from "../../../../Shared/ConfimationModal";
import UserDeleteBtn from "./UserDeleteBtn";
import axios from "axios";
import OpenSnackbar from "../../../../Shared/OpenSnackbar";

const AddUser = ({ classes, settings, setSettings }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [person, setPerson] = useState({
    value: "",
    isValid: "",
  });
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbar, setSnackbar] = useState({
    type: "",
    message: "",
  });
  const [count, setCount] = useState(0);

  const handleModalDelete = (user) => {
    ref.current = user;
    handleDeleteUser();
  };

  const { id } = useParams();
  const { user } = useContext(AuthContext);

  const ref = useRef(null);

  const validateEmail = (email) => {
    const regex =
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (regex.test(email)) {
      setPerson({ value: email, isValid: true });
    } else {
      setPerson({ value: email, isValid: false });
    }
  };

  const handleClickOpen = () => {
    setIsOpen(true);
  };

  const handleUsers = async () => {
    setCount(count + 1);
    try {
      const body = { email: person.value };
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}restaurant/cognito/${id}`,

        body
      );
      if (res) {
        setOpenSnackbar(true);
        if (res.data.message === "user already exist in table") {
          setSnackbar({
            type: "errorDark",
            message: "user already exists",
          });
          return;
        } else {
          setSnackbar({
            type: "successDark",
            message: "user added successfully",
          });
        }
      }
      const temp = settings.generalSettings;
      temp.admin_users.push(person.value);
      setSettings({ ...settings, generalSettings: temp });
    } catch (error) {
      if (error.message) {
        throw new Error(error.message);
      }
    } finally {
      setPerson({ isValid: "", value: "" });
      setIsOpen(false);
    }
  };

  const handleDeleteUser = async () => {
    let parentObj = settings?.generalSettings;
    const tempObj = settings?.generalSettings?.admin_users;
    const index = tempObj.indexOf(ref.current);
    if (index > -1) {
      tempObj.splice(index, 1);
    }

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}restaurant/cognito/user/delete/${id}`,

        {
          email: ref.current,
          admin_users: tempObj,
        }
      );
      if (res) {
        setOpenSnackbar(true);

        setSnackbar({
          type: "successDark",
          message: "user deleted successfully",
        });
      }
    } catch (error) {
      if (error.message) {
        throw new Error(error.message);
      }
    } finally {
      parentObj.admin_users = tempObj;
      setSettings({ ...settings, generalSettings: parentObj });
    }
  };

  return (
    <>
      <Grid container direction="row" spacing={5}>
        <Grid item xs={12} className={classes.mt30}>
          <Typography
            variant="h5"
            className={classes.typographyStyles}
            style={{ marginBottom: "10px" }}
          >
            Authorized User
          </Typography>
          <hr />
          {settings?.generalSettings?.admin_users?.length !== 0 &&
            settings?.generalSettings?.admin_users?.map((user, index) => (
              <Typography
                variant="body1"
                color="textPrimary"
                key={index}
                className={classes.typographyStyles}
              >
                User {index + 1} : {user}
                <UserDeleteBtn
                  user={user}
                  handleModalDelete={handleModalDelete}
                />
              </Typography>
            ))}
          <PrimaryButton
            handleClick={handleClickOpen}
            style={{ marginTop: "10px" }}
            testId={`add_an_user_button`}
          >
            ADD AN USER
          </PrimaryButton>
          {isOpen && (
            <Dialog open={isOpen} onClose={() => setIsOpen(false)}>
              <DialogTitle className={classes.typographyStyles}>
                Add An User
              </DialogTitle>
              <DialogContent>
                <TextField
                  autoFocus
                  margin="normal"
                  id="user"
                  label="Add an user"
                  type="email"
                  fullWidth
                  helperText={person.isValid === false && "Invalid Email"}
                  error={person.isValid === false}
                  variant="standard"
                  value={person.value}
                  inputProps={{
                    "aria-label": "add_user_email",
                  }}
                  onChange={(e) => validateEmail(e.target.value)}
                />
              </DialogContent>
              <DialogActions>
                <Button
                  variant="text"
                  style={{ color: "#09c491" }}
                  onClick={() => setIsOpen(false)}
                  data-testid="cancel_add_user_button"
                >
                  Cancel
                </Button>
                <Button
                  variant="text"
                  style={{
                    color: person.isValid ? "#09c491" : "#80d7bf",
                  }}
                  onClick={handleUsers}
                  disabled={!person.isValid}
                  data-testid="add_user_button"
                >
                  Add
                </Button>
              </DialogActions>
            </Dialog>
          )}
          <OpenSnackbar
            open={openSnackbar}
            setOpen={setOpenSnackbar}
            message={snackbar.message}
            type={snackbar.type}
            vertical="bottom"
            horizontal="center"
          />
        </Grid>
        <Grid item xs={12}></Grid>
      </Grid>
    </>
  );
};

export default AddUser;
